import { render } from "./Login.vue?vue&type=template&id=0af708be&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./login.scss?vue&type=style&index=0&id=0af708be&lang=scss&scoped=true"

import exportComponent from "/var/webapps/orangehrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af708be"]])

export default __exports__